import authCalls from "./service/authCalls";
import chapterCalls from "./service/chapterCalls";
import commentCalls from "./service/commentCalls";
import groupCalls from "./service/groupCalls";
import profileCalls from "./service/profileCalls";
import reactionCalls from "./service/reactionCalls";
import tagCalls from "./service/tagCalls";
import friendCalls from "./service/friendCalls";

const call = {
  auth: authCalls,
  chapter: chapterCalls,
  comment: commentCalls,
  group: groupCalls,
  profile: profileCalls,
  reaction: reactionCalls,
  tag: tagCalls,
  friend: friendCalls,
}


// const call = new Call();
export default call;
